var exports = {
  "kL": "xdbfd91f1--66f830--container",
  "LO": "xdbfd91f1--66f830--container-with-mortgage-annotations",
  "Qs": "xdbfd91f1--66f830--content",
  "Hs": "xdbfd91f1--66f830--photo-block",
  "cn": "xdbfd91f1--66f830--photo-label",
  "w7": "xdbfd91f1--66f830--annotation",
  "tX": "xdbfd91f1--66f830--title-container",
  "K2": "xdbfd91f1--66f830--logo-container",
  "YB": "xdbfd91f1--66f830--mortgage-annotations",
};

module.exports = exports;
